export default __webpack_public_path__ + "3446b33bd2c1c6f82b4a09dc26dc5dd9.png";